import { ReactNode } from "react";
import { useSelector } from "react-redux";

import NoAuthPage from "./NoAuthPage";

import { userState } from "state/user-slice";

type Props = {
  children?: ReactNode;
  noAuthElement?: ReactNode;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const RequireAuth: React.FC<Props> = ({ children, noAuthElement = NoAuthPage }) => {
  const user = useSelector(userState);

  if (!user.loggedIn) {
    return noAuthElement;
  }

  return children;
};

export default RequireAuth;
